import { MemberApplicationAddress } from "../entity";


const getAddress = (address: MemberApplicationAddress) => {
    const { street, zipCode, post, city } = address;
    return `${street}, ${city}, ${zipCode} ${post}`;
}

export {
    getAddress,
}